import styled from 'styled-components'

import media from '../../../utils/media'

export const CardWrapper = styled.div`
  position: relative;
  color: ${({ textColor, theme }) => theme.color[textColor]};
  border-radius: ${({ theme }) => theme.sizes.size8}px;
  background-color: ${({ bgColor, theme }) => theme.color[bgColor]};
  padding: ${({ padding, theme }) => padding || theme.sizes.size32}px;

  ${({ bdColor, theme }) =>
    bdColor &&
    `
    border: 1px solid ${theme.color[bdColor]};
  `}

  ${media.lessThan('xs')`
    padding: 16px;
  `}
`
